import { connect } from 'react-redux';
import { withBiEvent } from 'shared/bi/send-bi-event';
import autobind from 'core-decorators/lib/autobind';

import decorate from 'widget/utils/decorate';
import { playVideo } from 'widget/redux/client/actions/change-playback-status';
import { selectVideo } from 'widget/redux/client/actions/select-video';

import InFrameActions from './in-frame';


@connect(null, {
  playVideo,
  selectVideo,
})
@decorate(InFrameActions)
export default class InFrameMobileActionCallbacks extends React.Component {
  static propTypes = {
    children: React.PropTypes.element.isRequired,
    selectVideo: React.PropTypes.func.isRequired,
    playVideo: React.PropTypes.func.isRequired,
    onBeforeClick: React.PropTypes.func,
    onBeforePlayRequested: React.PropTypes.func,
    channelId: React.PropTypes.string,
    videoId: React.PropTypes.string,
    videoSource: React.PropTypes.string,
    isMainVideo: React.PropTypes.bool,
  };

  @autobind
  selectVideo() {
    const { selectVideo, videoId } = this.props;
    selectVideo(videoId);
  }

  @autobind
  @withBiEvent('widget.vid.clicked', function () {
    const { channelId, videoId, videoSource } = this.props;

    return {
      channelID: channelId,
      videoID: videoId,
      videoType: videoSource,
    };
  })
  playVideo() {
    const { playVideo, videoId } = this.props;
    playVideo(videoId);
  }

  @autobind
  handlePlayRequest() {
    const { isMainVideo, onBeforePlayRequested, onBeforeClick } = this.props;
    const handler = isMainVideo ?
      _.flow(onBeforePlayRequested, this.playVideo) :
      _.flow(onBeforeClick, this.selectVideo);

    handler();
  }

  render() {
    const { children } = this.props;
    const inFrameActions = _.omit(this.props, this.propTypes);

    return React.cloneElement(children, {
      ...inFrameActions,
      onPlayRequest: this.handlePlayRequest,
    });
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/actions/overlay-action-callbacks/in-frame-mobile.js